import React, {
  useCallback,
  useDeferredValue,
  useEffect,
  useState,
} from "react";
import { Helmet } from "react-helmet";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Spin, Table, Typography, message } from "antd";
import TableEmptyContent from "../../../Components/TableEmptyContent/TableEmptyContent";
import { FLIGHT_MODEL_MANAGEMENT_COLUMNS_HEAD } from "./FlightModelManagementUtils";
import AdminHeaderTab from "../../../Components/headerTab/AdminHeaderTab";
import { AddNewFlight } from "./AddNewFlight";
import { FlightModalAPI } from "../../../API/FlightModalAPI";
const { Text } = Typography;

function FlightModelManagement() {
  const [messageApi, contextHolder] = message.useMessage();
  const [spinning, setSpinning] = useState(false);
  const [addEmployeeModal, setAddEmployeeModal] = useState(false);
  const [flightModelList, setFlightModelList] = useState([]);
  const [serachVal, setSearchVal] = useState("");
  const [defualtData, setDefualtData] = useState([]);

  const serachFun = useCallback(() => {
    let arr = [...defualtData];
    const filterArr = arr.filter((ele) => {
      return (
        !serachVal.trim() ||
        String(`${ele.name}`)
          .toLowerCase()
          .includes(serachVal.trim().toLowerCase())
      );
    });
    setFlightModelList(filterArr);
  }, [defualtData, serachVal]);

  const deferredQuery = useDeferredValue(serachVal);
  useEffect(() => {
    serachFun();
  }, [deferredQuery, serachFun]);

  const messageToast = useCallback(
    (type, message) => {
      messageApi.open({
        type: type,
        content: message,
        duration: 6,
      });
    },
    [messageApi],
  );

  const loadConfigData = useCallback(async () => {
    setSpinning(true);
    await FlightModalAPI.getFlightModals()
      .then((res) => {
        if (res.data.status === true) {
          const arr = res.data?.flight_models.map((ele, index) => ({
            name: ele,
            serial_no: index + 1,
          }));
          setDefualtData(arr);
          setFlightModelList(arr);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setSpinning(false));
  }, [messageToast]);

  useEffect(() => {
    loadConfigData();
  }, [loadConfigData]);

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Admin</title>
      </Helmet>

      <AdminHeaderTab currrentTab="Flight Model Management" />

      <div className="admin_tab_content_wraper">
        <Spin spinning={spinning}>
          <div className="table_head_wraper">
            <Text className="table_head">Flight Model Management</Text>
            <div className="table_custom_buttons">
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#EBEEF8",
                  color: "#737373",
                  display: "flex",
                  marginRight: "10px",
                  flex: "1 1 0px ",
                }}
              >
                <input
                  value={serachVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                  className="searc_input"
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: !serachVal ? "#737373" : "#ff4d4f",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setAddEmployeeModal(true)}
              >
                Add New
              </Button>
            </div>
          </div>

          <div>
            <Table
              rowKey="serial_no"
              columns={FLIGHT_MODEL_MANAGEMENT_COLUMNS_HEAD}
              dataSource={flightModelList}
              pagination={{
                pageSize: 10,
                responsive: true,
                hideOnSinglePage: true,
              }}
              style={{ marginTop: "20px" }}
              className="antdTable"
              locale={{
                emptyText: <TableEmptyContent />,
              }}
            />
          </div>
        </Spin>
      </div>

      <AddNewFlight
        open={addEmployeeModal}
        setOpen={setAddEmployeeModal}
        messageToast={messageToast}
        loadConfigData={loadConfigData}
      />
      {contextHolder}
    </div>
  );
}

export default FlightModelManagement;
